import validate from 'lib/utils/validationRules';

const getDeal = state => {
  const { deal } = state.transaction;

  if (validate.isNull(deal)) {
    return null;
  }

  return deal;
};

const isRefundStatus = state => {
  const { status } = state.transaction;

  return ['REFUND_SUCCESS', 'REFUND_PROCESSING'].includes(status);
};

export default {
  getDeal,
  isRefundStatus,
};
